import Button from 'components/UI/Button/Button'
import styled from 'styled-components'
import fonts from 'themes/styles/fonts'

export const Wrapper = styled.div`
  min-width: 100vw;
  min-height: 540px;
  height: 100%;
  overflow: hidden;
  background-image: url("${ASSETS_PATH}/images/welcome-bg.jpg");
  background-size: cover;
  background-position: center;
  position: absolute;
  top: 0;
  left: 0;
  ${fonts.libreBaskerville};
`
export const PasswordForgotten = styled.div`
  max-width: 300px;
  margin: 0 auto;
  margin-top: 30px;
  a {
    text-decoration: underline;
  }
`

export const Clipboard = styled.div`
  position: relative;
  padding: 40px;
  height: 100%;
  color: #191464;
  text-align: center;
  background-color: #e8e8e8;
`

export const ClipboardContainer = styled.div`
  position: absolute;
  z-index: 1;
  max-width: 960px;
  width: 600px;
  height: calc(100% - 100px);
  border-radius: 20px 20px 0 0;
  background-color: #744d24;
  background-image: linear-gradient(
    to bottom,
    #744d24 0%,
    rgba(0, 0, 0, 0.4) 100%
  );
  padding: 20px 20px 0 20px;
  margin: 100px auto auto auto;
  box-shadow: 0 -10px 0 0 #936c43;
  left: 50%;
  transform: translateX(-50%);
`

export const Form = styled.div``

export const StyledInput = styled.input`
  left: 0;
  width: 300px;
  border-radius: 20px;
  padding: 10px;
  font-size: 20px;

  border: 3px solid ${props => (props.isWrong ? 'red' : '#191464')};
  margin-bottom: 5px;
`

export const Title = styled.h1`
  width: 100%;
  font-size: 24px;
  text-align: center;
  ${fonts.rammetto};
  text-transform: uppercase;
  letter-spacing: 1px;
  font-size: 24px;
  line-height: 1.3;
  margin: 0 0 25px 0;
`

export const Field = styled.div`
  margin-bottom: 25px;
`

export const Label = styled.div`
  width: 100%;
  text-align: center;
  font-size: 19px;
  margin-bottom: 10px;
`

export const ErrorMessage = styled.div`
  font-style: italic;
  color: red;
`

export const GoogleErrorMessage = styled(ErrorMessage)`
  font-style: italic;
  color: red;
  margin-bottom: 15px;
`

export const GoogleSection = styled.div`
  width: 195px;
  margin: 35px auto 0 auto;
`

export const ClipboardClip = styled.div`
  position: absolute;
  left: 50%;
  top: -40px;
  z-index: 2;
  margin-left: -150px;
  width: 300px;
  height: 80px;
  background-image: url("${ASSETS_PATH}/images/clipboard.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
`

export const ClassCode = styled.div`
  margin-top: 50px;
  font-size: 14px;
  color: #808080;

  & a {
    text-decoration: underline;
    color: inherit;
  }
`

export const PreviousStepButton = styled(Button)`
  position: absolute;
  top: 32px;
  left: 25px;
`
